<!-- 
<app-header></app-header>
<div class="dashboard-body">
  <app-side-bar></app-side-bar>
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
<app-footer></app-footer> -->

<div class="main-layout">
	 <app-header></app-header>
	<!-- <div class="content-layout"> -->
		<app-side-bar></app-side-bar>
		
	<!-- </div> -->
	<app-footer></app-footer>
</div>
